import React from 'react'
import i18n from './i18next_init'
import {
  I18nextProvider,
  withTranslation as i18nTranslate,
} from 'react-i18next'

const TranslationProvider = ({ children }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
)

export function translate(scope) {
  const TranslateComp = i18nTranslate(scope)

  return function (comp) {
    let hoc = TranslateComp(comp)
    hoc.defaultProps = { i18n }
    return hoc
  }
}

export default TranslationProvider
